export const style = {
  list: {
    margin: 0,
    padding: 0,
    listStyle: `none`
  },
  yearListItem: {
    borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
    cursor: `pointer`
  },
  yearWrapper: {
    fontSize: `14px`,
    fontWeight: 400,
    color: `#666`,
    padding: `5px 10px`,
    ':hover': {
      color: `#a94545`
    }
  },
  monthList: {
    display: `block`,
    position: `relative`,
    maxHeight: `0`,
    transition: `max-height 0.5s ease-in-out`,
    overflow: `hidden`
  },
  monthListActive: {
    maxHeight: `auto`
  },
  monthListItem: {
    borderBottom: `1px solid #ededed`
  },
  monthWrapper: {
    background: `#fafafa`,
    fontSize: `12px`,
    fontWeight: 400,
    color: `black`,
    padding: `7px 15px`,
    textDecoration: `none`,
    ':hover': {
      color: `#a94545`
    }
  },
  icon: {
    lineHeight: `24px`
  },
  monthIcon: {
    lineHeight: `18px`,
    width: `20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/navigation.js